import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import * as tribe from "./tribe-graphql";
import * as marital from "./marital-query";
import * as occupation from "./occupation-query";
import * as kin from "./kinship-query";
import * as patient from "./patient-reg-querry";
import * as bill from "./bill-query";
import * as cost_sharing from "./cost-sharing-query";
import * as facility from "./facility-query";

@Injectable({
  providedIn: "root",
})
export class RegConfigService {
  constructor(private apollo: Apollo) {}
  use = "registration";
  item = "item-configuration";

  genderList() {
    return [
      { id: "MALE", name: "Male" },
      { id: "FEMALE", name: "Female" },
    ];
  }

  startVisit(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: patient.startVisit,
      variables: {
        input: {
          clientMrn: payload.mrn,
          clientName: payload.fullName,
          administrativeAreaId: payload.area,
          costSharingModeSubgroupId: payload.sub_group,
          description: payload.service,
          reposition: "",
          mobileNumber: payload.mobileNumber,
          dob: payload.dob,
          gender: payload.gender,
          cardNo: payload.cardNo,
          authorizationNo: payload.authorizationNo,
          clientAddress: payload.clientAddress,
        },
      },
    });
  }

  saveBill(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: bill.saveBill,
      variables: {
        input: {
          mrn: payload.mrn,
          visitId: payload.visitId,
          payerName: payload.payerName,
          payerEmail: "",
          payerPhone: payload.mobile,
          queueCode: payload.queueCode,
          payOpt: 1,
          ccy: "TZS",
          description: payload.description,
          costSharingModeSubgroupId: payload.costSharingModeSubgroupId,
          itemDtoList: payload.items,
        },
      },
    });
  }

  savePatient(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: patient.save,
      variables: {
        input: {
          firstName: payload.firstName,
          middleName: payload.middleName,
          mobileNumber: payload.mobile,
          lastName: payload.lastName,
          tribe: {
            id: payload.tribe,
          },
          sex: payload.gender,
          maritalStatus: {
            id: payload.maritalStatus,
          },
          birthDate: payload.dob,
          administrativeArea: {
            id: payload.residence,
          },
        },
      },
    });
  }

  facilityTypes() {
    return this.apollo.watchQuery<any>({
      query: facility.facilityTypes,
      fetchPolicy: "no-cache",
    }).valueChanges;
  }

  services() {
    return this.apollo.watchQuery<any>({
      query: cost_sharing.facilityCostSharing,
      fetchPolicy: "no-cache",
    }).valueChanges;
  }

  saveKins(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: kin.save,
      variables: {
        input: {
          code: payload.code,
          name: payload.name,
          description: payload.description,
        },
      },
    });
  }

  saveFacility(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: facility.saveFacility,
      variables: {
        facilityDto: {
          email: payload.email,
          phone: payload.phone,
          address: payload.address,
          city: payload.city,
          facilityCode: payload.facilityCode,
          name: payload.name,
          residence: payload.administrativeAreaId,
          facilityTypeId: payload.facilityTypeId,
        },
      },
    });
  }

  mrnSeach(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: patient.search,
      variables: {
        input: payload,
      },
    });
  }

  public tribeSearch(payload: string) {
    return this.apollo.watchQuery<any>({
      query: patient.tribe,
      variables: {
        input: payload,
      },
    }).valueChanges;
  }
  public areaSearch(payload: string) {
    return this.apollo.watchQuery<any>({
      query: patient.area,
      variables: {
        input: payload,
      },
    }).valueChanges;
  }

  // UPDATE KINSHIP
  updateKins(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: kin.update,
      variables: {
        input: {
          id: payload.id,
          code: payload.code,
          name: payload.name,
          description: payload.description,
        },
      },
    });
  }

  // SAVE TRIBE
  savetribe(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: tribe.save,
      variables: {
        input: {
          name: payload.name,
        },
      },
    });
  }

  saveOccupations(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: occupation.save,
      variables: {
        input: {
          code: payload.code,
          name: payload.name,
          description: payload.description,
        },
      },
    });
  }

  // DELETE TRIBE
  deleteTribe(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: tribe.remove,
      variables: {
        input: payload.id,
      },
    });
  }

  // DELETE MARITAL STATUS
  deleteMarital(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: marital.remove,
      variables: {
        input: payload.id,
      },
    });
  }

  // GET ALL KINS
  kins(): Observable<any> {
    return this.apollo.watchQuery({
      fetchPolicy: "no-cache",
      query: kin.get,
    }).valueChanges;
  }

  // DELETE KINSHIP
  deleteKin(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: kin.remove,
      variables: {
        input: payload.id,
      },
    });
  }

  // GET ALL OCCUPATIONS
  occupations(): Observable<any> {
    return this.apollo.watchQuery({
      fetchPolicy: "no-cache",
      query: occupation.get,
    }).valueChanges;
  }

  // GET ALL TRIBES
  tribes(): Observable<any> {
    return this.apollo.watchQuery({
      fetchPolicy: "no-cache",
      query: tribe.get,
    }).valueChanges;
  }

  // GET ALL MARITAL STATUS
  maritalStatus(): Observable<any> {
    return this.apollo.watchQuery({
      fetchPolicy: "no-cache",
      query: marital.getAll,
    }).valueChanges;
  }
  // SAVE MARITAL
  saveMarital(payload): Observable<any> {
    return this.apollo.mutate({
      mutation: marital.save,
      variables: {
        input: {
          name: payload.name,
        },
      },
    });
  }
}
